import { MonthlyReport } from 'model';
import { createAsyncAction } from 'typesafe-actions';

export const getMonthlyReport = createAsyncAction(
  'monthlyReport/GET_MONTHLY_REPORT_REQUEST',
  'monthlyReport/GET_MONTHLY_REPORT_SUCCESS',
  'monthlyReport/GET_MONTHLY_REPORT_FAILURE',
)<undefined, MonthlyReport, undefined>();
